import { render, staticRenderFns } from "./outboundOrderDetail.vue?vue&type=template&id=6294f184&scoped=true&"
import script from "./outboundOrderDetail.vue?vue&type=script&lang=js&"
export * from "./outboundOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./outboundOrderDetail.vue?vue&type=style&index=0&id=6294f184&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6294f184",
  null
  
)

export default component.exports